import styles from '../../styles/pages/index.module.scss';
import { getContactInfo } from '../api/cms';
import ContactLayout from '../components/ContactLayout/ContactLayout';
import CustomHead from '../components/CustomHead';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import Navigation from '../components/Navigation/Navigation';
import { getOrFetchFooterLinks } from '../utils/footerLinks';
import { getOrFetchNavigationLinks } from '../utils/navigationLinks';

function ContactUs({ footerLinks, navigation, contact }) {
  const contactInfo = contact?.[0];
  return (
    <>
      <CustomHead title={contactInfo?.title} />
      <header className={styles.headerContainer}>
        <Header navigation={navigation} />
        <Navigation navigation={navigation} />
      </header>
      <ContactLayout contactInfo={contactInfo} />
      <Footer footerLinks={footerLinks} />
    </>
  );
}

export async function getStaticProps() {
  const [{ data: navigation }, footerLinks, { data: contact }] = await Promise.all([
    getOrFetchNavigationLinks(),
    getOrFetchFooterLinks(),
    getContactInfo(),
  ]);

  return {
    props: { navigation, footerLinks, contact },
  };
}

export default ContactUs;
